/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
 export const GET_ALL_REBATE_PROGRAMS = "GET_ALL_REBATE_PROGRAMS";
 export const SET_SUSPENDED_DT_DATA = "SET_SUSPENDED_DT_DATA";
 export const CHECKLOG_DATA = "CHECKLOG_DATA";
 export const SET_ERROR_MESSAGES = "SET_ERROR_MESSAGES";
 export const RESET_REMOVE_SUSPENDED_DATE_STORE = "RESET_REMOVE_SUSPENDED_DATE_STORE";
 